/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash f3d216a3fe4976491ef71c582b619e1c */

import { ConcreteRequest } from "relay-runtime";

import {  } from "relay-runtime";
export type CartNavRefetchQueryVariables = {
    fetchLocalItems: boolean;
    fetchPortfolioItems: boolean;
    hasUserId: boolean;
    localItemIds?: Array<string | null> | null | undefined;
    userIds?: Array<string> | null | undefined;
};
export type CartNavRefetchQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"CartNav_viewer">;
    };
};
export type CartNavRefetchQuery = {
    readonly response: CartNavRefetchQueryResponse;
    readonly variables: CartNavRefetchQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "fetchLocalItems"
        } as any,
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "fetchPortfolioItems"
        } as any,
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hasUserId"
        } as any,
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "localItemIds"
        } as any,
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "userIds"
        } as any
    ], v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v2 = {
        "kind": "Literal",
        "name": "first",
        "value": 3
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "amount",
        "storageKey": null
    } as any, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currency",
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "concreteType": "ConvertedAmountList",
        "kind": "LinkedField",
        "name": "convertedAmountList",
        "plural": true,
        "selections": [
            (v4 /*: any*/),
            (v3 /*: any*/)
        ],
        "storageKey": null
    } as any, v6 = [
        (v3 /*: any*/),
        (v4 /*: any*/),
        (v5 /*: any*/)
    ], v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalResults",
        "storageKey": null
    } as any, v8 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pdpURL",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "serviceId",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isSold",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "concreteType": "ItemPhoto",
            "kind": "LinkedField",
            "name": "photos",
            "plural": true,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemPhotoVersion",
                    "kind": "LinkedField",
                    "name": "versions",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "webPath",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ImageVersionType",
                            "kind": "LinkedField",
                            "name": "type",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "name",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                (v1 /*: any*/)
            ],
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "concreteType": "ItemPricing",
            "kind": "LinkedField",
            "name": "pricing",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "FinancialAmount",
                    "kind": "LinkedField",
                    "name": "netPrice",
                    "plural": false,
                    "selections": (v6 /*: any*/),
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "FinancialAmount",
                    "kind": "LinkedField",
                    "name": "salePrice",
                    "plural": false,
                    "selections": (v6 /*: any*/),
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "FinancialAmount",
                    "kind": "LinkedField",
                    "name": "retailPrice",
                    "plural": false,
                    "selections": (v6 /*: any*/),
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "concreteType": "AuctionLot",
            "kind": "LinkedField",
            "name": "relevantAuctionLot",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "FinancialAmount",
                    "kind": "LinkedField",
                    "name": "buyItNowPrice",
                    "plural": false,
                    "selections": [
                        (v5 /*: any*/)
                    ],
                    "storageKey": null
                },
                (v1 /*: any*/)
            ],
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "concreteType": "AuctionSolution",
            "kind": "LinkedField",
            "name": "relevantAuctionSolution",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "AuctionBidsConnection",
                    "kind": "LinkedField",
                    "name": "bids",
                    "plural": false,
                    "selections": [
                        (v7 /*: any*/)
                    ],
                    "storageKey": null
                },
                (v1 /*: any*/)
            ],
            "storageKey": null
        } as any,
        (v1 /*: any*/)
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "CartNavRefetchQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "fetchLocalItems",
                                    "variableName": "fetchLocalItems"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "fetchPortfolioItems",
                                    "variableName": "fetchPortfolioItems"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "localItemIds",
                                    "variableName": "localItemIds"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "CartNav_viewer"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "RootQueryType",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "CartNavRefetchQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        {
                            "condition": "fetchLocalItems",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": [
                                        (v2 /*: any*/),
                                        {
                                            "kind": "Variable",
                                            "name": "itemIds",
                                            "variableName": "localItemIds"
                                        }
                                    ],
                                    "concreteType": "ItemsConnection",
                                    "kind": "LinkedField",
                                    "name": "items",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ItemsEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Item",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": (v8 /*: any*/),
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ]
                        },
                        {
                            "condition": "hasUserId",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 1
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "portfolioTypes",
                                            "value": [
                                                "CART"
                                            ]
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "userIds",
                                            "variableName": "userIds"
                                        }
                                    ],
                                    "concreteType": "PortfoliosConnection",
                                    "kind": "LinkedField",
                                    "name": "portfolios",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "PortfoliosEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "PortfolioV2",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": [
                                                                (v2 /*: any*/)
                                                            ],
                                                            "concreteType": "PortfolioItemsConnection",
                                                            "kind": "LinkedField",
                                                            "name": "items",
                                                            "plural": false,
                                                            "selections": [
                                                                (v7 /*: any*/),
                                                                {
                                                                    "condition": "fetchPortfolioItems",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "PortfolioItemsEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "PortfolioItemV2",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "Item",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "item",
                                                                                            "plural": false,
                                                                                            "selections": (v8 /*: any*/),
                                                                                            "storageKey": null
                                                                                        },
                                                                                        (v1 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "items(first:3)"
                                                        },
                                                        (v1 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ]
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "ferrum/352.0.0-2022-02-11T14:31:47.735Z/CartNavRefetchQuery",
            "metadata": {},
            "name": "CartNavRefetchQuery",
            "operationKind": "query",
            "text": null
        }
    } as any;
})();
(node as any).hash = '66f9037c9d01b7778038030182b7bb5f';
export default node;
